import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { fetch_preschoolgoals, search_preschoolgoals } from 'actions/preschoolform';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Expandable } from 'UI';
import { Checkbox } from '@haldor/ui';

var SearchPreschoolGoal = /*#__PURE__*/function (_Component) {
  _inherits(SearchPreschoolGoal, _Component);

  var _super = _createSuper(SearchPreschoolGoal);

  function SearchPreschoolGoal(_props) {
    var _this;

    _classCallCheck(this, SearchPreschoolGoal);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.preschoolGoals.length < 1) {
        _this.props.fetch_preschoolgoals();
      }

      if (_this.props.selectedGoals && _this.props.selectedGoals.length > 0) {
        _this.setState({
          selectedGoals: _this.props.selectedGoals
        }, function () {
          if (_this.props.onChange != null) {
            _this.props.onChange(_this.state.selectedGoals);
          }
        });
      }

      _this.generateGroups(_this.props);
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      _this.generateGroups(nextProps);

      if (nextProps.selectedGoals) {
        if (nextProps.selectedGoals != _this.state.selectedGoals) {
          _this.setState({
            selectedGoals: nextProps.selectedGoals
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "generateGroups", function (props) {
      var groups = _this.state.groups; // Check if we have preschoolgoals and no groups

      if (props.preschoolGoals.length > 0 && groups.length < 1) {
        props.preschoolGoals.map(function (goal) {
          if (!groups.find(function (group) {
            return group.title === goal.group;
          })) {
            groups.push({
              title: goal.group,
              color: goal.colorCode
            });
          }
        });

        _this.setState({
          groups: groups
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onGoalSelect", function (goal) {
      var selectedGoals = _this.state.selectedGoals;
      var inArray = selectedGoals.find(function (sG) {
        return sG.goalId == goal.id;
      });

      if (!inArray) {
        selectedGoals.push({
          goalId: goal.id
        });
      } else {
        var index = selectedGoals.findIndex(function (pG) {
          return pG.goalId == goal.id;
        });
        selectedGoals.splice(index, 1);
      }

      _this.setState({
        selectedGoals: selectedGoals
      }, function () {
        if (_this.props.onChange) {
          _this.props.onChange(selectedGoals);
        }
      });
    });

    _this.state = {
      selectedGoals: [],
      groups: []
    };
    return _this;
  }

  _createClass(SearchPreschoolGoal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          preschoolGoals = _this$props.preschoolGoals,
          handleSubmit = _this$props.handleSubmit,
          change = _this$props.change,
          pristine = _this$props.pristine,
          reset = _this$props.reset,
          submitting = _this$props.submitting,
          valid = _this$props.valid;
      var _this$state = this.state,
          selectedGoals = _this$state.selectedGoals,
          groups = _this$state.groups;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container preschoolgoals-container"
      }, groups && preschoolGoals ? groups.map(function (group) {
        return /*#__PURE__*/React.createElement(Expandable, {
          headerStyles: {
            backgroundColor: group.color
          },
          title: group.title,
          key: 'select-' + group.title,
          whiteBackground: true
        }, preschoolGoals.map(function (goal) {
          var isChecked = selectedGoals.find(function (sg) {
            return sg.goalId == goal.id;
          });

          if (typeof isChecked != 'undefined') {
            isChecked = true;
          } else {
            isChecked = false;
          }

          return group.title === goal.group ? /*#__PURE__*/React.createElement("div", {
            key: 'select-goal-' + goal.title,
            className: "preschoolgoal-item",
            "data-tooltip": goal.text
          }, /*#__PURE__*/React.createElement(Checkbox, {
            value: isChecked,
            onChange: function onChange(e) {
              _this2.onGoalSelect(goal);
            },
            label: goal.title
          })) : null;
        }));
      }) : null);
    }
  }]);

  return SearchPreschoolGoal;
}(Component);

function mapStateToProps(state) {
  return {
    preschoolGoals: state.PreschoolGoals.preschoolGoals
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetch_preschoolgoals: fetch_preschoolgoals,
    search_preschoolgoals: search_preschoolgoals
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchPreschoolGoal);